import FieldInterpolation from  "./FieldInterpolation.vue";
import _ from 'lodash';
export default {
  name: "TableList",
  components: {
    FieldInterpolation
  },
  data: function(){
    return {
      window: {
        width: 0,
        height: 0
      },
      privateHeaders: [],
      additionalAuthorize: [],
      actionData:{
        Get: {icon: 'fas fa-eye', label:'Visualizar'},
        Update: {icon: 'fas fa-highlighter', label:'Editar'},
        Delete: {icon: 'fas fa-trash-alt', label:'Remover'},
        Add: {icon: 'fas fa-plus', label:'Adicionar'}
      }
    }
  },
  props: {
    headers:{
      type: Array,
      required: true
    },
    itemList: {
      type: Array,
      required: true
    },
    pagination: {
      type: Object
    },
    permissionIsAuthorize: {
      type: String
    },
    authorizeActions: {
      type: Array,
      required: false,
      default: () => ['Get','Update','Delete']
    },
    additionalActions: {
      type: Array,
      required: false,
      default: () => []
    },
    styleClass: {
      type: Object,
      required: false,
      default: () => ({th:'border-0', td: ''})
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    tableIsFixed: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: 'Campos'
    },
    GetReport:{
      type: Function,
      required: false
    },
    noHeader:{
      type: Boolean,
      required: false,
      default: false
    },
  },
  watch: {
    pagination() {
      this.$emit('update:pagination', this.pagination);
    },
    "pagination.PageNumber"() {
      this.$emit("List");
    },
    "pagination.RowsPerPage"() {
      this.$emit("List");
    },
    headers(){
      this.SetHeaderDefaultValues();
    }
  },
  computed:{
    hasAction(){
      let hasAuth = false;
      if(this.authorizeActions.length > 0){
        hasAuth = this.authorizeActions.some(action => this.VerifyPermission({IsExcluded: false}, action, true));
      }
      let hasAuthAdditional = false;
      if(this.additionalActions.length > 0){
        hasAuthAdditional = this.additionalActions.some(action => this.VerifyPermission({IsExcluded: false}, action, true));
      }
      return hasAuth || hasAuthAdditional;
    },
    totalItems(){
      return this.pagination != undefined ? this.pagination.TotalItems : this.itemList.length;
    },
    onlyOneAction(){
      return (this.additionalActions.length + this.authorizeActions.length) == 1;
    }
  },
  mounted(){
    if(this.additionalActions.length > 0){
      this.additionalAuthorize = this.additionalActions.map(action => action.authorization);
    }
    this.SetHeaderDefaultValues();
  },
  methods: {
    SetHeaderDefaultValues(){
      this.privateHeaders = this.headers.map(item => {
        if(Array.isArray(item.field)){
          item.field.forEach(itemField => {
            itemField.class = itemField.class != undefined ? itemField.class : "";
          });
        }
        item.classHeader = item.classHeader != undefined ? item.classHeader : "";
        item.classField = item.classField != undefined ? item.classField : "";
        item.style = item.style != undefined ? item.style : "";
        return item;
      });
    },
    
    ReturnEvent(eventName, ev, data, index) {
      ev.preventDefault();
      this.$emit(eventName, data, index, eventName);
    },

    Report(ev) {
      ev.preventDefault();
      this.GetReport();
    },

    VerifyPermission(item, action, isHasAction = false){
      if(typeof action == 'string'){
        return (this.permissionIsAuthorize != undefined && this.$isAuthorize(this.permissionIsAuthorize, action))
             && !this.additionalAuthorize.includes(action) && this.authorizeActions.includes(action) && !item.IsExcluded
      }else{
        if(action.customRule && !isHasAction){
          return action.customRule(item);
        }else{
          if(!action.page){
            const haveToAuth = this.permissionIsAuthorize != undefined;
            const isAuth = haveToAuth ? this.$isAuthorize(this.permissionIsAuthorize, action.authorization) : true;
            return !item.IsExcluded && isAuth;
          }else{
            const isAuth = this.$isAuthorize(action.page, action.authorization);
            return !item.IsExcluded && isAuth;
          }
        }
      }
    },

    /**
     * Function used to read a Object inside another using a string as parameter
     * @param {object} data Ex: { Client: { Address: { Street: 'Groove Street' } } }
     * @param {string} field Ex: 'Client.Address.Street'
     * @returns Ex: 'Groove Street'
     */
    ResolveFieldData(data, field) {
      if(data && field) {
        if (this.isFunction(field)) {
          return field(data);
        }
        else if(field.indexOf('.') == -1) {
          return data[field];
        }
        else {
          let fields = field.split('.');
          let value = data;
          for(let i = 0, len = fields.length; i < len; ++i) {
            if (value == null) {
              return null;
            }
            value = value[fields[i]];
          }
          return value;
        }
      }
      else {
        return null;
      }
    },
    
    isFunction(obj) {
      return !!(obj && obj.constructor && obj.call && obj.apply);
    }
  }
};


// WEBPACK FOOTER //
// ./src/components/sub-components/Generic/TableList/TableList.js